'use client'

import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/classnames'

import { HowItWorksStep } from './steps'

const HowItWorksHeader = ({ steps, stepIndex }: { steps: HowItWorksStep[]; stepIndex: number }) => {
  const { t } = useTranslation()

  return (
    <div className='mx-auto max-w-5xl px-4'>
      <div className='text-left md:text-center'>
        <p className='text-[13px] font-semibold uppercase tracking-[0.16em] text-[#F3603C]'>{t('Landing.Text.HowItWorks')}</p>
        <h2 id='how-it-works-title' className='mt-3 scroll-mt-28 text-3xl font-bold tracking-tight text-blue-950'>
          {t('Landing.Text.HowItWorksHeading')}
        </h2>
        <div className='mt-4 grid max-w-xl md:mx-auto'>
          {steps.map((step, index) => (
            <p
              key={step.title}
              aria-hidden={index !== stepIndex}
              className={cn(
                'col-start-1 row-start-1 text-lg leading-relaxed text-slate-500 transition-opacity duration-500',
                index === stepIndex ? 'opacity-100' : 'pointer-events-none opacity-0',
              )}
            >
              {step.description}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HowItWorksHeader
